var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSettingsInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.25c.285.285-.08.353 1.044 1.027M7.125 8.25c-.136.273-.59.609-1.125.928m0 0c-.64.383-1.398.743-1.875.947-2.625 1.5-2 5.125-1.875 6.75h13.5c.125-1.75.15-5.55-2.25-6.75-.72-.36-1.6-.634-1.956-.848M6 9.18 8.822 12l2.722-2.723",
    stroke: "#323657"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 16.875V14.25m-8.25 2.625V14.25",
    stroke: "#323657",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.75,
    y: 0.5,
    width: 6.5,
    height: 8,
    rx: 3.25,
    stroke: "#323657"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 2.625c.75.625 2.85 1.5 5.25 0",
    stroke: "#323657"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSettingsInfo);
export default __webpack_public_path__ + "static/media/user-settings-info.0eed84243dbbff427186083c90e99de5.svg";
export { ForwardRef as ReactComponent };